import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";

import PageTitle from "../components/common/PageTitle";
import { showError, showSuccess } from "../utils/toast";

import {
  validateRequired,
  validateEmail,
  validatePasswordMatch,
  validatePasswordLength,
} from "../utils/validation";

export default function Register() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);

  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [hp, setHp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedProject, setSelectedProject] = useState("");

  const [loading, setLoading] = useState(false);

  // ================= LOAD PROJECT =================
  useEffect(() => {
    loadProjects();
  }, []);

  async function loadProjects() {
    try {
      const res = await apiClient.get("/public/projects");
      setProjects(res.data || []);
    } catch {
      showError("Gagal memuat project");
    }
  }

  // ================= REGISTER =================
  async function handleRegister(e) {
    e.preventDefault();

    if (!validateEmail(email)) return;
    if (!validatePasswordMatch(password, confirmPassword)) return;
    if (!validatePasswordLength(password)) return;

    if (!validateRequired({ nama, email, hp, password })) return;

    try {
      setLoading(true);

      await apiClient.post("/register", {
        nama,
        email,
        hp,
        password,
        project_id: selectedProject || null,
      });

      showSuccess("Registrasi berhasil, silakan login");

      navigate("/login");
    } catch (err) {
      showError(err.response?.data?.error || "Registrasi gagal");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow">
        
        <PageTitle>Register</PageTitle>

        <form onSubmit={handleRegister} className="space-y-4 mt-4">

          {/* PROJECT */}
          <select
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">Pilih Project</option>
            {projects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>

          {/* NAMA */}
          <input
            placeholder="Nama"
            value={nama}
            onChange={(e) => setNama(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          {/* EMAIL */}
          <input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          {/* HP */}
          <input
            placeholder="No HP"
            value={hp}
            onChange={(e) => setHp(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          {/* PASSWORD */}
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          {/* CONFIRM PASSWORD */}
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full border px-3 py-2 rounded"
          />

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition"
          >
            {loading ? "Loading..." : "Register"}
          </button>

          {/* LINK LOGIN */}
          <p className="text-sm text-center text-gray-500">
            Sudah punya akun?{" "}
            <span
              className="text-blue-600 cursor-pointer"
              onClick={() => navigate("/login")}
            >
              Login
            </span>
          </p>

        </form>
      </div>
    </div>
  );
}
